.icon {
  display: inline-block;
  vertical-align: middle;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  overflow: visible;
}

/* RTL (golf 3): pijlen en chevrons wijzen de leesrichting op. */
[dir='rtl'] .directional {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
